import { useState } from "react";
import { ISelectableItem, SelectWithSearch } from "../select-with-search";
import { changeAssignee } from "service/api";

export const SelectableManagerWithSearch = ({
  assignmentId,
  selectedManager,
  optionsManagers,
  disabled,
}: {
  assignmentId: string;
  selectedManager: ISelectableItem;
  optionsManagers: ISelectableItem[];
  disabled?: boolean;
}) => {
  const [isSelectDisabled, setSelectDisabled] = useState(disabled);

  const onSelect = async (option: ISelectableItem) => {
    try {
      setSelectDisabled(true);
      await changeAssignee({ assignmentId, userId: option.value });
    } catch (error) {
      console.error(error);
    } finally {
      setSelectDisabled(false);
    }
  };

  return (
    <SelectWithSearch
      value={selectedManager}
      options={optionsManagers}
      disabled={isSelectDisabled}
      onSelect={onSelect}
    />
  );
};
